// Where the Game Day Lab is offered: development, staging and UAT, never production. A mock game
// on production would be a real fixture in front of real fans, with real pushes and real points.
//
// The CMS build carries no environment name (the deploy config lives on the servers), so this goes
// by the address the page is served from. It is an allowlist: an address that is not listed, the
// production domain included, gets no lab. The backend refuses the mock endpoints on its own
// (APP_ENV), so this only decides whether the page is shown, not whether mock games can be made.
export const LAB_HOSTS = [
  'localhost',
  '127.0.0.1',
  'p4pdev.niftycoders.net',
  'p4pstage.niftycoders.net',
  'p4p-uat.niftycoders.net'
];

export function isGameDayLabAvailable(hostname = window.location.hostname) {
  return LAB_HOSTS.includes(String(hostname || '').toLowerCase());
}
